"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = (0, tslib_1.__importDefault)(require("react"));
const Svg_1 = (0, tslib_1.__importDefault)(require("./Svg"));
const SvgUser = (_a) => {
    var { size = 24 } = _a, props = (0, tslib_1.__rest)(_a, ["size"]);
    return (react_1.default.createElement(Svg_1.default, Object.assign({ fill: "currentColor", viewBox: "0 0 24 24", size: size }, props),
        react_1.default.createElement("path", { fill: "currentColor", d: "M12 9a3.984 3.984 0 100-7.969A3.984 3.984 0 0012 9zM19.969 18.984a3.981 3.981 0 01-3.985 3.985H8.016a3.981 3.981 0 01-3.985-3.985A7.962 7.962 0 0112 11.016a7.962 7.962 0 017.969 7.968z" })));
};
exports.default = SvgUser;
//# sourceMappingURL=User.js.map